<script>
import THelp from '~/components/THelp';

export default {
  extends: THelp,

  props: {
    label: {
      type: String,
      required: false,
      default:
        'Benennen Sie das Unternehmensprofil nach Ihrer Firma. Dieser Titel wird den Bewerber:innen bei der Kontaktaufnahme angezeigt. (z.B. Mustermann GmbH, Muster Health GmbH)',
    },
  },
};
</script>
